import React, { createContext, useEffect, useRef } from 'react';

import { bind } from 'bind-event-listener';

export const ElementEventListener = ({
	handler,
	children,
}: {
	children: React.ReactNode;
	handler?: RightClickHandlerFn;
}): React.JSX.Element => {
	const wrapperRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (!wrapperRef.current || !handler) {
			return;
		}

		const handleMouseDown = (e: MouseEvent) => {
			const isLink = (e.target as Element).closest('a');
			if (isLink && e.button !== 0) {
				handler(true);
			}
		};

		const unbind = bind(wrapperRef.current, {
			type: 'mousedown',
			listener: handleMouseDown,
		});

		return unbind;
	}, [handler]);

	return <span ref={wrapperRef}>{children}</span>;
};

const ElementEventListenerContext = createContext<RightClickHandlerFn | undefined>(undefined);

export function ElementEventListenerProvider({
	children,
	handler,
}: {
	children: React.ReactNode;
	handler: RightClickHandlerFn;
}): React.JSX.Element {
	return (
		<ElementEventListenerContext.Provider value={handler}>
			{children}
		</ElementEventListenerContext.Provider>
	);
}

export function useElementEventListenerHandler(): RightClickHandlerFn | undefined {
	const context = React.useContext(ElementEventListenerContext);
	return context;
}

type RightClickHandlerFn = (isRightClick?: boolean) => void;
